(function () {
    document.addEventListener("DOMContentLoaded", () => {
        const closeButton = document.querySelector(".banner-close-button");
        const offerBanner = document.getElementById("offer");

        closeButton.addEventListener("click", () => {
            offerBanner.style.display = "none"; // Hides the banner
        });
    });
})();